import * as scenes from '../scenes'
import * as overlayStyle from '../../../constants/overlayStyles'
import * as customFieldTypes from '../../../constants/customFieldTypes'
import * as sidebarSceneType from '../../../constants/sidebarSceneType'
import * as stylePresetType from '../../../constants/stylePresetType'

const customFields = [
  {
    id: 'intro',
    location: { scene: scenes.INTRO, showcaseNum: 0 },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'intro', 'image' ],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [[ 'intro', 'image' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'in_intro__doors',
        customStyle: '.in_intro__doors {\n}\n.in_static-logo {\n}',
        stylePresets: [
          { title: 'Zoom:', className: `in_intro__doors`, presetType: stylePresetType.ZOOM },
          { title: 'Darken\\Lighten Image:', className: `in_intro__door`, presetType: stylePresetType.DARKEN_LIGHTEN },
          { title: 'Pan:', className: 'in_intro__doors', presetType: stylePresetType.POSITION },
        ]
      },
      {
        id: 'logo',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'intro', 'logo' ]],
        overlayStyle: overlayStyle.BlueField,
        overlayKey: 'in_static-logo-intro',
        customStyle: '.in_static-logo-intro {\n}',
        stylePresets: [
          { title: 'Image position:', className: `in_static-logo-intro`, presetType: stylePresetType.POSITION },
          { title: 'Image size:', className: `in_static-logo-intro`, presetType: stylePresetType.ZOOM },
          { title: 'Add background around image:', className: `in_static-logo-intro`, presetType: stylePresetType.AROUND }
        ]
      },
      {
        id: 'bulletPoints',
        type: customFieldTypes.BULLET_POINTS,
        name: 'Edit Bullet Points',
        paths: [
          [ 'intro', 'line1' ],
          [ 'intro', 'line2' ],
          [ 'intro', 'line3' ]
        ],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'in_intro__content',
        customStyle: [1, 2, 3].map(i => `.in_intro__content-line_${i} {\n}\n`),
        stylePresets: [
          { title: 'Text color:', className: 'in_intro__content', presetType: stylePresetType.COLOR, options: ['black', 'white'] },
          { title: 'Text effects:', className: `in_intro__content`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `in_intro__content-line`, presetType: stylePresetType.TEXT_SIZE },
        ]
      }
    ]
  },
  {
    id: `showcase`,
    location: { scene: scenes.SHOWCASE },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'intro', 'image' ]
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.INSTA_LAYOUT,
        name: 'Layout',
        paths: [[ 'appSettings', 'columns' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'in_grid_images'
      },
      {
        id: 'logo',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'intro', 'showcaseLogo' ]],
        overlayStyle: overlayStyle.BlueField,
        overlayKey: 'in_showcases_logo',
        customStyle: '.in_showcases_logo {\n}',
        stylePresets: [
          { title: 'Image position:', className: `in_showcases_logo`, presetType: stylePresetType.POSITION },
          { title: 'Image size:', className: `in_showcases_logo`, presetType: stylePresetType.ZOOM },
          { title: 'Add background around image:', className: `in_showcases_logo`, presetType: stylePresetType.AROUND }
        ]
      },
    ]
  },
  {
    id: `tagProducts`,
    location: { scene: scenes.SHOWCASE },
    siderbarPreview: {
      type: sidebarSceneType.HIDDEN
    }
  },
  {
    id: `appPreview`,
    location: { scene: scenes.SHOWCASE },
    siderbarPreview: {
      type: sidebarSceneType.HIDDEN
    }
  }
]

export default customFields



// WEBPACK FOOTER //
// ./src/templates/insta/template/customFields.js